import { ACLInheritDataTaskDto } from './aclInheritDataTask.dto';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { UserDto } from './user.dto';

export enum TaskExecutionStatus{
    NEW = 0,
    IN_PROGRESS = 1,
    FINISHED = 2,
    FAILED_CANCELLED = 3
}

export class ACLInheritDataTaskExecutionDto extends BaseDto{  
    user: UserDto;
    sourceMerchant: MerchantDto;
    targetMerchant: MerchantDto;
    task: ACLInheritDataTaskDto;
    processOutput: string;
    status: TaskExecutionStatus;
    process: number;
}